// assets/upside-ship-line.js  (2026-10-21)
// Simon 2026-10-21: show what shipping costs right under the subtotal of our cart drawer, so the total at checkout
// is no surprise (the drawer already shows the amount to free shipping in its progress bar; this does not repeat it).
//   under the threshold: "Shipping to Québec   $9.99" (the cost in the promo red)
//   at or over it:       "Shipping to Québec   FREE"
// Rates and thresholds are the live General delivery profile (read 2026-10-21): EAST ON/QC $9.99 free from $75,
// ROC AB/BC/MB/SK $19.99 free from $125, ATLANTIC NB/NL/NS/PE $19.99 free from $150. Territories and the US are
// carrier rates and Advent calendars have their own profile: no row there. Shipping is a pricing decision made in
// the upside-ship skill; if a rate or threshold changes in Shopify, change the table below too.
// Read-only: one GET /cart.js, one inserted row inside OUR drawer footer. It never touches a product form, Add to Cart,
// window.fetch or any event (1_upside-drinks/CLAUDE.md).
// Switch off: deploy-ship-line.mjs --restore (removes the script tag), or add ?ud_ship_line=off to a URL to test without it.
(function () {
  'use strict';
  if (window.UDShipLine) return;
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var OFF = false;
  try { OFF = /[?&]ud_ship_line=off\b/.test(location.search); } catch (e) {}

  var ZONES = [
    { codes: ['ON', 'QC'], rate: 999, min: 7500 },
    { codes: ['AB', 'BC', 'MB', 'SK'], rate: 1999, min: 12500 },
    { codes: ['NB', 'NL', 'NS', 'PE'], rate: 1999, min: 15000 }
  ];
  var NAMES = {
    ON: ['Ontario', 'Ontario'], QC: ['Québec', 'Québec'], AB: ['Alberta', 'Alberta'], BC: ['British Columbia', 'Colombie-Britannique'],
    MB: ['Manitoba', 'Manitoba'], SK: ['Saskatchewan', 'Saskatchewan'], NB: ['New Brunswick', 'Nouveau-Brunswick'],
    NL: ['Newfoundland and Labrador', 'Terre-Neuve-et-Labrador'], NS: ['Nova Scotia', 'Nouvelle-Écosse'], PE: ['Prince Edward Island', 'Île-du-Prince-Édouard']
  };
  var T = FR ? { ship: 'Livraison : ', free: 'GRATUITE' } : { ship: 'Shipping to ', free: 'FREE' };
  var ADVENT_IDS = { 7521447084229: 1, 7523569729733: 1, 8107846631621: 1, 10344329445573: 1 };   // same list as upside-cart.js hasAdvent()

  function money(c) { return '$' + ((c || 0) / 100).toFixed(2); }
  function cookie(k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  // same source as upside-cart.js province(): the header "Deliver to" selector
  function province() {
    var p = '';
    try { var L = window.ecomificShoppingLocation; p = (L && L.getLocation && L.getLocation()) || ''; } catch (e) {}
    if (!p) p = cookie('ecomific_shopping_location');
    return String(p || '').trim().toUpperCase();
  }
  function zoneFor(p) {
    for (var i = 0; i < ZONES.length; i++) if (ZONES[i].codes.indexOf(p) > -1) return ZONES[i];
    return null;
  }
  function hasAdvent(cart) {
    return (cart.items || []).some(function (it) {
      return ADVENT_IDS[it.product_id] || /advent|(^|[^a-z])l?avent([^a-z]|$)/i.test((it.handle || '') + ' ' + (it.product_title || ''));
    });
  }
  // same total as the progress bar: cart total minus lines that need no shipping
  function shippingTotal(cart) {
    var excl = 0;
    (cart.items || []).forEach(function (it) { if (it.requires_shipping === false) excl += it.final_line_price; });
    return Math.max(0, cart.total_price - excl);
  }
  // pure: what the row says for a province and a cart, or null for no row
  function calc(p, cart) {
    var z = zoneFor(p);
    if (!z || !cart || !cart.item_count || hasAdvent(cart)) return null;
    var free = shippingTotal(cart) >= z.min;
    return { place: (NAMES[p] || [p, p])[FR ? 1 : 0], free: free, rate: z.rate };
  }
  window.UDShipLine = { calc: calc };
  if (OFF) return;

  var row = null, timer = null, watching = null;
  function css() {
    if (document.getElementById('ud-ship-line-css')) return;
    var s = document.createElement('style');
    s.id = 'ud-ship-line-css';
    s.textContent = '.ud-cart__ship{display:flex;justify-content:space-between;align-items:baseline;font-size:15px;margin:0 0 6px;color:#202A36}' +
      '.ud-cart__ship[hidden]{display:none}' +
      '.ud-cart__ship b{font-weight:700;color:#A9322F}' +
      '.ud-cart__ship b.is-free{color:#37446E}';
    document.head.appendChild(s);
  }
  function getRow(sub) {
    if (!row) { row = document.createElement('div'); row.className = 'ud-cart__ship'; row.hidden = true; }
    // keep it right under the subtotal even when the delivery estimate is inserted there after us
    if (row.previousElementSibling !== sub) sub.insertAdjacentElement('afterend', row);
    return row;
  }
  function paint(sub, res) {
    var r = getRow(sub);
    if (!res) { r.hidden = true; return; }
    r.innerHTML = '<span></span><b></b>';
    r.firstChild.textContent = T.ship + res.place;
    var b = r.lastChild;
    b.textContent = res.free ? T.free : money(res.rate);
    b.className = res.free ? 'is-free' : '';
    r.hidden = false;
  }
  function refresh() {
    var sub = document.querySelector('.ud-cart__sub');
    if (!sub) return;
    window.fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
      .then(function (cart) { paint(sub, calc(province(), cart)); })
      .catch(function () { paint(sub, null); });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 150); }
  // upside-eta.js adds the delivery estimate under the subtotal after we do: put the shipping row back right under it
  function keepUnderSub() {
    var sub = document.querySelector('.ud-cart__sub');
    if (row && sub && row.parentNode && row.previousElementSibling !== sub) sub.insertAdjacentElement('afterend', row);
  }
  // the drawer sets .ud-cart__subamt on every render: that is our cue
  function attach() {
    var amt = document.querySelector('.ud-cart__subamt');
    if (!amt || watching === amt) return;
    watching = amt;
    css();
    new MutationObserver(schedule).observe(amt, { childList: true, characterData: true, subtree: true });
    var footer = document.querySelector('.ud-cart__footer');
    if (footer) new MutationObserver(keepUnderSub).observe(footer, { childList: true });
    schedule();
  }
  attach();
  new MutationObserver(attach).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('ud:cart.change', schedule);
})();
